/* global gRootURL: readonly, gBuildVersion: readonly, FS: readonly */

var pendingCallbacks = [];

export function loadCodeMirror6(callback) {
	var cm = window.CodeMirror6;
	if (cm) {
		callback(cm);
		return;
	}
	if (pendingCallbacks.push(callback) === 1) {
		FS.addScript(gRootURL + "/js/codemirror6-bundle.min.js?v=" + gBuildVersion, function () {
			var cm = window.CodeMirror6;
			for (var i = 0; i < pendingCallbacks.length; i++)
				pendingCallbacks[i](cm);
			pendingCallbacks = [];
		});
	}
}
